import Vue from 'vue'
import router from '../../src/router'

export default {
	hosturl:'http://api.hefeigc.com',  
	imgurl:'http://47.104.19.238/gaochuang/source/', //图片地址
	getUrlParam:function(name) {
	     var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
	     var r = window.location.search.substr(1).match(reg);
	     if (r!= null) {
	        return unescape(r[2]);
	     }else{
	        return null;
	     }
	},   
	getLocalTime:function(nS) {    //时间戳转时间 
      var date = new Date(nS*1000);
		var Y = date.getFullYear() + '-';
		var M = (date.getMonth()+1 < 10 ? '0'+(date.getMonth()+1) : date.getMonth()+1) + '-';
		var D = (date.getDate()< 10 ? '0'+date.getDate():date.getDate() ) + ' ';
		var h = (date.getHours()<10?'0'+date.getHours():date.getHours()) + ':';
		var m = (date.getMinutes()<10?'0'+date.getMinutes():date.getMinutes()) + ':';
		var s = (date.getSeconds()<10?'0'+date.getSeconds():date.getSeconds()); 
		return Y+M+D+' '+h+m+s;    
    },
    request(params){
		let url=this.hosturl+params.url;
		let data=params.data||{}; 
		let method = 'post';
		let body=data;
		Vue.http({
			method:method,
			url:url,
			body:body,
			headers:{
				token:''
			},
			emulateJSON:true
		}).then((res) =>{
			if(res.body.code==200){
				params.success(res);
			}else if(res.body.code==1002){
				router.push({path:'/login'});
			}else{
				params.error(res);
			}
		})
	},
    HTMLEncode:function (html) {   //转义
	    var temp = document.createElement("div");
	    (temp.textContent != null) ? (temp.textContent = html) : (temp.innerText = html);
	    var output = temp.innerHTML;
	    temp = null;
	    return output;
	}, 
	HTMLDecode:function(text) {    //反转义
	    var temp = document.createElement("div");
	    temp.innerHTML = text;
	    var output = temp.innerText || temp.textContent;
	    temp = null;
	    return output;
	},
	version:function(){            //随机数
		return parseInt(Math.random(100)*100);
	}
}







//////////////////
// WEBPACK FOOTER
// ./static/js/common.js
// module id = /sA3
// module chunks = 30